export const GET_TRACKERS = "GET_TRACKERS";
export const GET_TRACKER_BY_ID = "GET_TRACKER_BY_ID";
export const UPDATE_TRACKER = "UPDATE_TRACKER";
export const DELETE_TRACKER = "DELETE_TRACKER";
export const CREATE_TRACKER = "CREATE_TRACKER";
